export enum PriceType {
  TOTAL_PRICE = 'TOTAL',
  PRICE_BY_NIGHT = 'NIGHT',
}
